import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { AppContextProvider } from '@contexts/AppContext';
import { HomeProps } from '@interfaces/homepage';

import HomeContent from './Content';

const queryClient = new QueryClient();

const Home = (props: HomeProps) => {
  return (
    <AppContextProvider
      env={props.env}
      initialCurrentUser={props.initialCurrentUser}
      isGdprRequired={props.isGdprRequired}
      isWebview={props.isWebview}
    >
      <QueryClientProvider client={queryClient}>
        <HomeContent {...props} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};

export default Home;
